import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://a9d8604bfd3af7e15e9fea00cd18e372@o4511093249146880.ingest.de.sentry.io/4511093254389840",
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV,
  // No IP addresses, cookies or user details in events (privacy / DPA).
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Session replay — records DOM mutations and sends replays.
    // All text and inputs are masked and media blocked, so no names, statuses or comments leave the browser.
    // TODO: Disable after debugging MAQS Outlook white screen issue.
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 1.0, // TODO: Lower after debugging MAQS Outlook issue
  replaysOnErrorSampleRate: 1.0,
});

